define('views/content/reports/sales',['require','backbone','marionette','bootstrap-daterangepicker','datatables','text!templates/content/reports/sales.html'],function(require){

    var Backbone = require('backbone');
    require('marionette');
    require('bootstrap-daterangepicker');
    require('datatables');

    var temp = require("text!templates/content/reports/sales.html");

    return Backbone.Marionette.CompositeView.extend({
        // html template for the view
        template: _.template(temp),
        className: 'report-page',
        titleKey: 'sales',

        initialize: function(options) {
            App.context.changePageTitle(App.polyglot.t(this.titleKey));
        },

        ui: function() {
            return {
                reportDateRangePicker: '#report-range-picker',
                reportDateRangeTabs: '.report-range-tabs',
                reportDateRangeTab: '.report-range-tabs li',

                resellerSalesTable: '.reseller-sales-list',
                overallSalesTable: '.overall-sales-list'
            };
        },

        events: {
            'click @ui.reportDateRangeTab': 'reportDateRangeTabClicked'
        },

        onRender: function () {
            var _this = this;

            this.ui.reportDateRangePicker.daterangepicker({
                timePicker: false,
                format:'YYYY-MM-DD',
                autoApply: true
            });

            this.ui.reportDateRangePicker.on('hide.daterangepicker', function () {
                _this.getReports();
            });

            var startTime = localStorage.getItem('report_start_time');
            var endTime = localStorage.getItem('report_end_time');
            if (startTime && endTime) {
                this.ui.reportDateRangePicker.data('daterangepicker').setStartDate(new Date(parseInt(startTime)));
                this.ui.reportDateRangePicker.data('daterangepicker').setEndDate(new Date(parseInt(endTime)));

                this.getReports();
            } else {
                this.ui.reportDateRangeTabs.find('li[data-range="day"]').click();
            }
        },

        reportDateRangeTabClicked: function (e) {
            var clickedTab = $(e.currentTarget);
            var currentTab = this.ui.reportDateRangeTabs.find('li.active');

            if (clickedTab != currentTab) {
                currentTab.removeClass('active');
                clickedTab.addClass('active');

                var rangeKey = clickedTab.attr('data-range');

                var tomorrow = new Date();
                tomorrow.setDate(tomorrow.getDate() + 1);

                if (rangeKey == 'day') {
                    var today = new Date();

                    this.ui.reportDateRangePicker.data('daterangepicker').setStartDate(today);
                    this.ui.reportDateRangePicker.data('daterangepicker').setEndDate(tomorrow);
                } else if (rangeKey == 'week') {
                    var weekStart = App.utils.getWeekStart();

                    this.ui.reportDateRangePicker.data('daterangepicker').setStartDate(weekStart);
                    this.ui.reportDateRangePicker.data('daterangepicker').setEndDate(tomorrow);
                } else if (rangeKey == 'month') {
                    var monthStart = App.utils.getMonthStart();

                    this.ui.reportDateRangePicker.data('daterangepicker').setStartDate(monthStart);
                    this.ui.reportDateRangePicker.data('daterangepicker').setEndDate(tomorrow);

                } else if (rangeKey == 'year') {
                    var yearStart = App.utils.getYearStart();

                    this.ui.reportDateRangePicker.data('daterangepicker').setStartDate(yearStart);
                    this.ui.reportDateRangePicker.data('daterangepicker').setEndDate(tomorrow);
                } else if (rangeKey == 'last_30_days') {
                    var monthAgo = new Date(tomorrow.getTime());
                    monthAgo.setDate(monthAgo.getDate() - 30);

                    this.ui.reportDateRangePicker.data('daterangepicker').setStartDate(monthAgo);
                    this.ui.reportDateRangePicker.data('daterangepicker').setEndDate(tomorrow);
                }

                this.getReports();
            }
        },

        getReports: function () {
            var _this = this;

            // Save date parameters in local storage
            localStorage.setItem('report_start_time', this.ui.reportDateRangePicker.data('daterangepicker').startDate.toDate().getTime());
            localStorage.setItem('report_end_time', this.ui.reportDateRangePicker.data('daterangepicker').endDate.toDate().getTime());

            $.ajax({
                url: App.Config.apiBase + 'reports/sales-reports/',
                method: 'get',
                data: {
                    start_date: this.ui.reportDateRangePicker.data('daterangepicker').startDate.format('YYYY-MM-DD'),
                    end_date: this.ui.reportDateRangePicker.data('daterangepicker').endDate.format('YYYY-MM-DD')
                },
                success: function (response) {
                    _this.showResellerSaleReports(response.reseller_report);
                    _this.showOverallSaleReports(response.overall_report);
                }
            });
        },

        showResellerSaleReports: function (reportData) {
            // Transform report data for datatables format
            var gridData = [];

            var totalRow = {
                count: 0,
                price: 0
            };

            reportData.forEach(function (reportRow) {
                gridData.push([
                    '<a href="/products/' + reportRow.product.id + '">' + reportRow.product.name + '<a/>',
                    '<a href="/resellers/' + reportRow.reseller.id + '">' + reportRow.reseller.name + '<a/>',
                    reportRow.count,
                    (reportRow.price.toFixed(2) + ' $')]);

                totalRow.count += reportRow.count;
                totalRow.price += reportRow.price;
            });

            // Add total row
            gridData.push([
                App.polyglot.t('total'),
                '',
                totalRow.count,
                (totalRow.price.toFixed(2) + ' $')
            ]);

            if (!this.resellerSalesDataTable) {
                this.resellerSalesDataTable = this.ui.resellerSalesTable.DataTable({
                    paging: false,
                    ordering: false,
                    info: false,
                    searching: false,
                    data: gridData,
                    columns: [
                        { title: App.polyglot.t('product') },
                        { title: App.polyglot.t('reseller') },
                        { title: App.polyglot.t('count'), className: 'text-right' },
                        { title: App.polyglot.t('price'), className: 'text-right' }
                    ]
                });
            } else {
                this.resellerSalesDataTable.clear();
                this.resellerSalesDataTable.rows.add(gridData);
                this.resellerSalesDataTable.columns.adjust().draw();
            }
        },

        showOverallSaleReports: function (reportData) {
            // Transform report data for datatables format
            var gridData = [];

            var totalRow = {
                count: 0,
                price: 0
            };

            reportData.forEach(function (reportRow) {
                gridData.push([
                    '<a href="/products/' + reportRow.product.id + '">' + reportRow.product.name + '<a/>',
                    reportRow.count,
                    (reportRow.price.toFixed(2) + ' $')]);

                totalRow.count += reportRow.count;
                totalRow.price += reportRow.price;
            });

            // Add total row
            gridData.push([
                App.polyglot.t('total'),
                totalRow.count,
                (totalRow.price.toFixed(2) + ' $')
            ]);

            if (!this.overallSalesDataTable) {
                this.overallSalesDataTable = this.ui.overallSalesTable.DataTable({
                    paging: false,
                    ordering: false,
                    info: false,
                    searching: false,
                    data: gridData,
                    columns: [
                        { title: App.polyglot.t('product') },
                        { title: App.polyglot.t('count'), className: 'text-right' },
                        { title: App.polyglot.t('price'), className: 'text-right' }
                    ],
                    buttons: [
                        'print'
                    ]
                });
            } else {
                this.overallSalesDataTable.clear();
                this.overallSalesDataTable.rows.add(gridData);
                this.overallSalesDataTable.columns.adjust().draw();
            }
        }

    });
});
